import { render, staticRenderFns } from "./coachIndex.vue?vue&type=template&id=0fa815e7&scoped=true&"
import script from "./coachIndex.vue?vue&type=script&lang=js&"
export * from "./coachIndex.vue?vue&type=script&lang=js&"
import style0 from "./coachIndex.vue?vue&type=style&index=0&id=0fa815e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa815e7",
  null
  
)

export default component.exports